import React, { useCallback } from "react";

export default function Overlooked(props) {
    const { session, sendUrlParameter, categories } = props;
    const favorites = session.player?.favorites;

    const renderMenuIcon = useCallback((icon, index) => {
        return (
            <button
                className="game-app-icon-item"
                key={icon.id || index}
                onClick={() => sendUrlParameter(`?game_category=${icon.name}`)}
            >
                <div className="img-holder">
                    <div className={"kategorija kat-" + icon.id}></div>
                </div>
                <div className="icon-info-box">
                    <div className="icon-info">
                        <p className="game-name">{icon.name}</p>
                        <p className="games-number">{icon.brojIgara}</p>
                        <img src="../_SharedComponents/Assets/Icons/ic_arrow_red_r_2x.png" alt="right arrow" />
                    </div>
                    <hr />
                </div>
            </button>
        )
    }, [sendUrlParameter]);

    const renderSubMenuIcons = useCallback(() => {
        let updatedCategories = [...categories]

        if (favorites) {
            const myGames = {
                "id": 0,
                "name": "Moje igre",
                "aktivno": true,
                "defaultSort": 1,
                "brojIgara": favorites.length,
                "odabrano": null
            }
            updatedCategories.unshift(myGames);
        }

        return updatedCategories
            .filter(category => category.aktivno)
            .map((category, index) => renderMenuIcon(category, index));
    }, [categories, favorites]);

    return (
        <div className="overlooked-wrapper">
            <h2>Je li ti promaklo?</h2>
            <div className="overlooked">
                {renderSubMenuIcons()}
            </div>
            <hr/>
        </div>
    )
}
